import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { BoardEditColumnInput } from '../boardEditColumnInput';

export const BoardAddNewColumn = ({ onCreateColumn }) => {
  const [isEditing, setIsEditing] = useState(false);

  const onSubmit = (value) => {
    const parsedValue = value.trim();

    setIsEditing(false);
    onCreateColumn(parsedValue).catch(() => {
      setIsEditing(true);
    });
  };

  return (
    <Flex sx={{ width: isEditing ? '360px' : '32px', flexShrink: 0 }}>
      <>
        {isEditing ? (
          <BoardEditColumnInput onChange={onSubmit} onCancel={() => setIsEditing(false)} />
        ) : (
          <Flex
            alignItems="center"
            justifyContent="center"
            width="32px"
            height="32px"
            sx={{
              cursor: 'pointer',
              borderRadius: '4px',
              border: '1px solid',
              borderColor: 'border.subtle',
              color: 'neutral.400',
              '&:hover': {
                backgroundColor: 'neutral.20',
                color: 'neutral.500',
              },
            }}
            onClick={() => setIsEditing(true)}
          >
            <Box as={Plus} height="16px" width="16px" aria-hidden="true" />
          </Flex>
        )}
      </>
    </Flex>
  );
};

BoardAddNewColumn.propTypes = {
  onCreateColumn: PropTypes.func,
};

BoardAddNewColumn.defaultProps = {
  onCreateColumn: null,
};
